import { render, staticRenderFns } from "./ShowTabs.vue?vue&type=template&id=db9b0a58&"
import script from "./ShowTabs.vue?vue&type=script&lang=js&"
export * from "./ShowTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports